const PURCHASE_STATUSES = [
  { key: "paid", label: "Payment secured", className: "bg-sky-50 text-sky-700" },
  { key: "fulfilled", label: "Receipt confirmation", className: "bg-brand-gold/10 text-[#8a5a00]" },
  { key: "completed", label: "Completed", className: "bg-brand-green/10 text-brand-greendark" },
  { key: "cancelled", label: "Cancelled", className: "bg-navy-50 text-mut" },
  { key: "disputed", label: "Under dispute", className: "bg-brand-red/10 text-brand-reddark" },
  { key: "refunded", label: "Refunded", className: "bg-navy-50 text-navy-600" },
  { key: "resolved", label: "Resolved", className: "bg-brand-green/10 text-brand-greendark" },
] as const;

export type PurchaseStatusFilter = "all" | typeof PURCHASE_STATUSES[number]["key"];
export const PURCHASE_STATUS_FILTERS: ReadonlyArray<{ key: PurchaseStatusFilter; label: string }> = [
  // [items.purchase-workspace](../../../docs/product/items.md#items-purchase-workspace): split-dispute outcomes remain visible under All without a separate filter chip.
  { key: "all", label: "contracts.filter.all" }, ...PURCHASE_STATUSES.filter(({ key }) => key !== "resolved"),
];

// Contracts, purchase details and process cards share terminal translations;
// payment/handover phases keep their purchase-specific meanings.
export function purchaseStatusLabel(status: string, translate?: (key: string) => string): string {
  if (translate && (status === "completed" || status === "cancelled")) return translate(`transaction.status.${status}`);
  return PURCHASE_STATUSES.find(({ key }) => key === status)?.label ?? status.replace(/_/g, " ");
}

export function purchaseStatusClass(status: string): string {
  return PURCHASE_STATUSES.find(({ key }) => key === status)?.className ?? "bg-navy-50 text-mut";
}
